import useWaitingMutation from '@common/hooks/useWaitingMutation';
import { deleteFile } from '../../services/requestService';
import { MutateOptions } from '@tanstack/react-query';
 
export const useDeleteFile = () => {
  const { isLoading, mutate } = useWaitingMutation((fileName: string) => {
    return deleteFile(fileName);
  });
 
  type WrapOptions = (MutateOptions<any, unknown, string, unknown> | undefined) & { onFinished?: () => void };
 
  const deleteFile2 = (fileName: string, options?: WrapOptions) =>
    mutate(fileName, {
      ...options,
      onSuccess: (data, variables, context) => {
        options?.onSuccess && options?.onSuccess(data, variables, context);
        options?.onFinished && options?.onFinished();
      },
      onError: (error, variables, context) => {
        options?.onError && options?.onError(error, variables, context);
        options?.onFinished && options?.onFinished();
      },
    });
 
  return { isDeleteingInProgress: isLoading, deleteFile: deleteFile2 };
};